<span *ngIf="pageScrolled" class="back-to-top-icon" (click)="backToTop()"></span>